import { mutate } from "swr";

export const mutateWithStartKey = (startKey: string) => {
  mutate(
    (key) => typeof key === "string" && key.startsWith(startKey),
    undefined,
    { revalidate: true }
  );
};
